import { FunctionComponent, ReactNode, useContext } from 'react'
import styled, { css } from 'styled-components'
import contextToiTeaser from '@contexts/toiTeaser'
import { TOITeaserLayoutContextType } from '@contexts/toiTeaser'
import { desktopCSS, mobileCSS, tabletCSS } from '@measures/responsive'

type StyledTextWrapperProps = Pick<TOITeaserLayoutContextType, 'teaserRatio'>

const { TOITeaserLayoutContext } = contextToiTeaser

const StyledTextWrapper = styled.div<StyledTextWrapperProps>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 0;
  ${({ teaserRatio }) => {
    const [ratioHorizontalDesktop, ratioVerticalDesktop] = teaserRatio[
      'desktop'
    ]
      .split('_')
      .map((teaserRatio) => parseInt(teaserRatio, 10))

    const [ratioHorizontalTablet, ratioVerticalTablet] = teaserRatio['tablet']
      .split('_')
      .map((teaserRatio) => parseInt(teaserRatio, 10))

    const [ratioHorizontalMobile, ratioVerticalMobile] = teaserRatio['mobile']
      .split('_')
      .map((teaserRatio) => parseInt(teaserRatio, 10))

    return css`
      ${desktopCSS(css`
        padding-bottom: ${(ratioVerticalDesktop * 100) /
        ratioHorizontalDesktop}%;
      `)}

      ${tabletCSS(css`
        padding-bottom: ${(ratioVerticalTablet * 100) / ratioHorizontalTablet}%;
      `)}

      ${mobileCSS(css`
        padding-bottom: ${(ratioVerticalMobile * 100) / ratioHorizontalMobile}%;
      `)}
    `
  }};
`

const TextWrapper: FunctionComponent<{ children?: ReactNode }> = ({
  children,
}) => {
  const { teaserRatio } = useContext(TOITeaserLayoutContext)

  return (
    <StyledTextWrapper teaserRatio={teaserRatio}>{children}</StyledTextWrapper>
  )
}

export default TextWrapper
